import { render } from "./ScriptsList.vue?vue&type=template&id=13809166"
import script from "./ScriptsList.vue?vue&type=script&lang=js"
export * from "./ScriptsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__